import React from "react";

const SectionSubtitle = ({ subtitle, overrideStyles }) => {
  return (
    <span className="text-section-description-sm md:text-section-description-md lg:text-section-description-lg font-section-description text-xs md:text-sm lg:text-md ">
      {subtitle}
    </span>
  );
};

export default SectionSubtitle;
